import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import Multiselect from 'multiselect-react-dropdown';
import { useSelector } from 'react-redux';
import { selectQueryParams } from '../../ui/customerListingReducer';

const FiltersPartial = (props) => {
  const { filtersModel, setFiltersModel } = props;
  const queryParams = useSelector(selectQueryParams);
  const options = [
    {
      id: 'active',
      name: 'Active'
    },
    {
      id: 'blocked',
      name: 'Blocked'
    },
    {
      id: 'defective',
      name: 'Defective'
    },
    {
      id: 'deleted_by_sap',
      name: 'Deleted By SAP'
    },
  ];

  const onStatusesAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, statuses: [...(prevState?.statuses || []), selectedOption.id] }
    })
  }

  const onStatusesRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, statuses: prevState.statuses.filter((id) => id !== removedOption.id) }
    })
  }

  return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
    <div>
      <Form.Group className="mb-3">
        <Form.Label>Status</Form.Label>
        <Multiselect
          options={options}
          selectedValues={queryParams.filters?.statuses ?
            options.filter((item) => queryParams.filters?.statuses.includes(item.id)) :
              props.filtersModel?.statuses ?
              options.filter((item) => props.filtersModel?.statuses.includes(item.id)) :
            []
          }
          fieldName="statuses"
          stateModel={filtersModel}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onStatusesAdded}
          onRemove={onStatusesRemove}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
          placeholder="Select Status"
        />
      </Form.Group>
    </div>
  </Filters>
};

export default FiltersPartial;
